import * as React from "react";
import ProductTeaser, { IProductTeaserProps } from "~/components/product-teaser/product-teaser";

export interface IProductTeaserViewProps {
    contextModel: IProductTeaserProps;
}

class ProductTeaserView extends React.PureComponent<IProductTeaserViewProps> {
    public render() {
        return <ProductTeaser {...this.props.contextModel} />;
    }
}

export default ProductTeaserView;
